(function(){
  if(window.__hmRh) return; window.__hmRh=true;
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth=reduce?'auto':'smooth';

  /* ---------- Galerie : carrousel + miniatures + curseur + zoom ---------- */
  function gallery(root){
    var car=$('[data-rh-carousel]',root); if(!car) return;
    var slides=$$('.product-gallery__media',car), thumbsBox=$('[data-rh-thumbs]',root), thumbs=thumbsBox?$$('.product-gallery__thumbnail',thumbsBox):[];
    var cur=0, programmatic=false, pt;
    function idx(){var best=0,bd=1e9;slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-car.scrollLeft);if(d<bd){bd=d;best=i}});return best}
    function mark(i){
      cur=i;
      slides.forEach(function(s,k){s.classList.toggle('is-selected',k===i)});
      thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===i?'true':'false')});
      if(thumbsBox&&thumbs[i]){
        var t=thumbs[i];
        try{thumbsBox.scrollTo({left:t.offsetLeft-thumbsBox.clientWidth/2+t.clientWidth/2,top:t.offsetTop-thumbsBox.clientHeight/2+t.clientHeight/2,behavior:smooth})}catch(e){}
      }
    }
    function go(i,instant){
      i=Math.max(0,Math.min(slides.length-1,i)); programmatic=true;
      car.scrollTo({left:slides[i].offsetLeft,behavior:instant?'auto':smooth});
      mark(i); clearTimeout(pt); pt=setTimeout(function(){programmatic=false},instant?50:700);
    }
    car.addEventListener('scroll',function(){ if(programmatic) return; clearTimeout(car.__t); car.__t=setTimeout(function(){var i=idx(); if(i!==cur) mark(i)},60)},{passive:true});
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
    root.__rhGo=go; root.__rhIndex=function(){return cur}; root.__rhSlides=slides;
    mark(0);
    /* curseur personnalisé + clic gauche/droite (souris) */
    var wrap=car.parentElement, cursor=$('custom-cursor',wrap);
    if(window.matchMedia&&matchMedia('(pointer:fine)').matches){
      wrap.addEventListener('pointermove',function(e){
        if(!cursor) return;
        if(e.target.closest('button,a[href]')){cursor.classList.remove('is-visible');return}
        var r=wrap.getBoundingClientRect(), half=e.clientX<(r.left+r.right)/2;
        cursor.classList.toggle('is-half-start',half);cursor.classList.toggle('is-half-end',!half);cursor.classList.add('is-visible');
        var x=e.clientX-r.left-cursor.clientWidth/2,y=e.clientY-r.top-cursor.clientHeight/2;
        cursor.style.translate=x.toFixed(2)+'px '+y.toFixed(2)+'px';
      },{passive:true});
      wrap.addEventListener('pointerleave',function(){if(cursor)cursor.classList.remove('is-visible','is-half-start','is-half-end')});
      car.addEventListener('click',function(e){
        if(e.target.closest('button,a[href]')) return;
        var r=car.getBoundingClientRect(); (e.clientX-r.left>car.clientWidth/2)?go(cur+1):go(cur-1);
      });
    }
    var z=$('[data-rh-zoom]',root); if(z) z.addEventListener('click',function(){lightbox(root,cur)});
  }

  /* ---------- Zoom (lightbox) ---------- */
  function lightbox(root,start){
    var srcs=root.__rhSlides.map(function(s){var im=$('img',s);var ss=im.getAttribute('srcset')||'';var best=im.currentSrc||im.src;
      ss.split(',').forEach(function(p){var u=p.trim().split(' ');if(u[0])best=u[0]});return {src:best,alt:im.alt}});
    var i=start, ov=document.createElement('div'); ov.className='hm-rh-lb';
    ov.innerHTML='<style>.hm-rh-lb{position:fixed;inset:0;z-index:2147483000;background:#fff;display:flex;align-items:center;justify-content:center;font-family:Montserrat,sans-serif}.hm-rh-lb img{max-width:100%;max-height:100%;object-fit:contain;transition:transform .2s;cursor:zoom-in}.hm-rh-lb img.z{transform:scale(2);cursor:zoom-out}.hm-rh-lb__x{position:absolute;top:16px;right:16px;border:0;background:none;padding:0;cursor:pointer;width:56px;height:56px}.hm-rh-lb__bar{position:absolute;bottom:16px;left:0;right:0;display:flex;justify-content:center;align-items:center;gap:16px;font-size:14px;color:#1a1a1a}.hm-rh-lb__bar button{border:0;background:none;font-size:22px;cursor:pointer;padding:6px 12px;color:#1a1a1a}</style><button class="hm-rh-lb__x" type="button" aria-label="Fermer"><svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/><path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/><path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/></svg></button><img alt=""><div class="hm-rh-lb__bar"><button type="button" data-p aria-label="Précédent">‹</button><span><b data-c></b> / '+srcs.length+'</span><button type="button" data-n aria-label="Suivant">›</button></div>';
    var im=$('img',ov),c=$('[data-c]',ov);
    function show(n){i=(n+srcs.length)%srcs.length;im.src=srcs[i].src;im.alt=srcs[i].alt;im.classList.remove('z');c.textContent=i+1}
    function close(){document.removeEventListener('keydown',key);ov.remove();document.documentElement.style.overflow='';root.__rhGo&&root.__rhGo(i,true)}
    function key(e){if(e.key==='Escape')close();if(e.key==='ArrowRight')show(i+1);if(e.key==='ArrowLeft')show(i-1)}
    im.addEventListener('click',function(){im.classList.toggle('z')});
    $('.hm-rh-lb__x',ov).addEventListener('click',close);$('[data-p]',ov).addEventListener('click',function(){show(i-1)});$('[data-n]',ov).addEventListener('click',function(){show(i+1)});
    document.addEventListener('keydown',key);document.documentElement.style.overflow='hidden';document.body.appendChild(ov);show(i);
  }

  /* ---------- Sélecteur de couleurs (packs) + ajout au panier ---------- */
  function tikb(root){
    var box=$('[data-rh-tikb]',root), src=$('[data-rh-data]',root); if(!box||!src) return;
    var cfg; try{cfg=JSON.parse(src.textContent)}catch(e){return}
    var ord=Object.keys(cfg.swatches||{});var V=cfg.variants.slice().sort(function(a,b){var i=ord.indexOf(a.name),j=ord.indexOf(b.name);return (i<0?99:i)-(j<0?99:j)}), tel=V.map(function(){return 0}), busy=false;
    var fmt; try{fmt=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:cfg.currency||'EUR'})}catch(e){fmt=null}
    function money(c){ if(fmt){try{return fmt.format(c/100)}catch(e){}} return (c/100).toFixed(2).replace('.',',')+' '+(cfg.currency||'') }
    function count(){return tel.reduce(function(a,b){return a+b},0)}
    function total(){return V.reduce(function(s,v,i){return s+v.price*tel[i]},0)}
    function lowest(){return V.reduce(function(m,v){return Math.min(m,v.price)},V[0].price)}
    var rij=$('[data-rij]',box), info=$('[data-info]',box), wis=$('[data-wis]',box), atc=$('[data-atc]',box), lab=$('[data-atc-label]',box), err=$('.tk-err',box), boven=$('[data-boven]',box);
    function bg(name){var s=cfg.swatches&&cfg.swatches[name]; if(!s) return '#ffffff'; return /^#|^rgb/.test(s)?s+' center/cover':'url('+s+') center/cover'}
    /* Change l'image du carrousel sans jamais déplacer la page */
    function toMedia(k){
      var v=V[k]; if(!v||!v.media||!root.__rhSlides) return;
      var i=-1; root.__rhSlides.forEach(function(s,n){if(+s.getAttribute('data-media-id')===v.media)i=n});
      if(i>=0&&root.__rhGo) root.__rhGo(i);
    }
    function draw(){
      rij.innerHTML=V.map(function(v,i){var n=tel[i],off=v.available===false;
        return '<button type="button" class="tk-sw'+(n>0?' aan':'')+'" data-plus="'+i+'"'+(off?' disabled':'')+' title="'+v.name+'" aria-label="'+v.name+'"><span class="tk-cirkel" style="background:'+bg(v.name)+'"></span>'+(n>0?'<span class="tk-badge" data-min="'+i+'" role="button" aria-label="'+cfg.tMinus+'">×'+n+'</span>':'')+'</button>'}).join('');
      var n=count(),tot=total();
      boven.textContent=n===0?cfg.tPick:cfg.tMore; wis.hidden=n===0;
      info.innerHTML=n===0?'<b>'+money(lowest())+'</b> · '+cfg.tOne:'<b>'+n+' '+(n>1?cfg.tPacks:cfg.tPack)+'</b> · '+(n*4)+' '+cfg.tHooks+' · '+money(tot/n)+' '+cfg.tEach;
      atc.disabled=n===0||busy; lab.textContent=cfg.tAtc+' · '+money(n===0?lowest():tot);
    }
    box.addEventListener('click',function(e){
      var m=e.target.closest('[data-min]'); if(m){e.preventDefault();e.stopPropagation();var i=+m.dataset.min;if(tel[i]>0){tel[i]--;draw()}return}
      if(e.target.closest('[data-wis]')){tel=V.map(function(){return 0});draw();return}
      var p=e.target.closest('[data-plus]'); if(p&&!p.disabled){var k=+p.dataset.plus; tel[k]++; draw(); toMedia(k)}
    });
    atc.addEventListener('click',function(){
      if(busy||atc.disabled) return; busy=true; atc.disabled=true; err.hidden=true; lab.textContent=cfg.tBusy;
      var items=[]; V.forEach(function(v,i){if(tel[i]>0) items.push({id:v.id,quantity:tel[i]})});
      var rootUrl=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){
          try{ if(window.HomyriaCart&&HomyriaCart.afterAdd){ return HomyriaCart.afterAdd(function(){location.assign(rootUrl+'cart')}) } }catch(e){}
          location.assign(rootUrl+'cart');
        })
        .catch(function(){err.textContent=cfg.tErr;err.hidden=false;busy=false;draw()});
    });
    /* Noir présélectionné (1 pack) */
    V.some(function(v,i){if(/noir/i.test(v.name)&&v.available!==false){tel[i]=1;return true}});
    draw();
  }

  /* ---------- Fenêtre des moyens de paiement ---------- */
  function pay(root){
    var open=$('#pay_secured',root), pop=$('#paymenticons',root), info=$('.product-info',root), close=pop&&$('#close',pop); if(!open||!pop) return;
    function t(on){pop.classList.toggle('fade-in',on);if(info)info.classList.toggle('product-info-popup',on)}
    open.addEventListener('click',function(){t(!pop.classList.contains('fade-in'))});
    if(close) close.addEventListener('click',function(){t(false)});
    pop.addEventListener('click',function(e){if(e.target===pop)t(false)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')t(false)});
  }

  /* ---------- Accordéons (aria-expanded pour la flèche) ---------- */
  function accordions(){
    $$('details.accordion').forEach(function(d){
      if(d.__rh) return; d.__rh=1;
      d.addEventListener('toggle',function(){d.setAttribute('aria-expanded',d.open?'true':'false')});
    });
  }

  /* ---------- Bouton « Découvrez la puissance » : mène au bouton Ajouter au panier ---------- */
  function scrollers(){
    $$('[data-rh-scroll]').forEach(function(b){
      if(b.__rh) return; b.__rh=1;
      b.addEventListener('click',function(){
        var t=$('#hm-tikb [data-atc]')||$('#hm-tikb'); if(!t) return;
        var r=t.getBoundingClientRect();
        window.scrollTo({top:Math.max(0,r.top+(window.pageYOffset||0)-(innerHeight-r.height)/2),behavior:smooth});
      });
    });
  }

  /* ---------- Vidéos : lecture quand visibles ---------- */
  function videos(){
    var vs=$$('[data-rh-video]'); if(!vs.length) return;
    if(!('IntersectionObserver' in window)){vs.forEach(function(v){var vm=v.closest('video-media');if(vm)vm.setAttribute('loaded','');v.play&&v.play().catch(function(){})});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(en){var v=en.target;if(en.isIntersecting){var p=v.play&&v.play();if(p&&p.catch)p.catch(function(){})}else{v.pause&&v.pause()}})},{threshold:.25});
    vs.forEach(function(v){var vm=v.closest('video-media');function mark(){if(vm)vm.setAttribute('loaded','')}
      v.muted=true;v.addEventListener('loadeddata',mark);v.addEventListener('playing',function(){mark();if(vm)vm.setAttribute('playing','')});if(v.readyState>=2)mark();io.observe(v)});
  }

  /* ---------- Avis : maçonnerie + « Afficher plus » ---------- */
  function reviews(){
    var wrap=$('[data-rh-avis]'); if(!wrap) return;
    var grid=$('#grid',wrap), items=$$('.grid-item-wrap',grid), btn=$('#loadMore',wrap), step=20, shown=0;
    function cols(w){return w>=920?4:(w>=480?3:(w>=320?2:1))}
    function layout(){
      var w=grid.clientWidth; if(!w) return; var n=cols(w), cw=w/n, hs=[];
      for(var i=0;i<n;i++) hs.push(0);
      items.forEach(function(it){
        if(it.hidden) return;
        it.style.position='absolute';it.style.width=cw+'px';it.style.visibility='visible';
        var k=hs.indexOf(Math.min.apply(null,hs)); it.style.left=(k*cw)+'px'; it.style.top=hs[k]+'px'; hs[k]+=it.offsetHeight;
      });
      grid.style.position='relative'; grid.style.height=Math.max.apply(null,hs)+'px';
    }
    function show(){shown+=step;items.forEach(function(it,i){it.hidden=i>=shown});layout()}
    show();
    if('ResizeObserver' in window) new ResizeObserver(function(){layout()}).observe(grid); else window.addEventListener('resize',layout);
    $$('img',grid).forEach(function(im){if(!im.complete) im.addEventListener('load',layout)});
    window.addEventListener('load',layout);
    if(btn) btn.addEventListener('click',function(){
      if(shown<items.length){show();if(shown>=items.length&&!btn.__last){btn.__last=1}return}
      btn.disabled=true;btn.textContent=btn.getAttribute('data-loading');setTimeout(function(){btn.textContent=btn.getAttribute('data-fail')},900);
    });
    var sum=$('.summary-content',wrap), dist=$('.reviews-dist',wrap);
    if(sum&&dist) sum.addEventListener('click',function(){
      var open=sum.getAttribute('aria-expanded')==='true'; sum.setAttribute('aria-expanded',open?'false':'true'); dist.style.display=open?'none':'block';
      var o=$('.chevron-open',sum),c=$('.chevron-closed',sum); if(o&&c){o.classList.toggle('chevron-hide',!open);c.classList.toggle('chevron-hide',open)}
    });
  }

  function init(){
    $$('[data-rh-product]').forEach(function(r){try{gallery(r);tikb(r);pay(r)}catch(e){console.error('hm-rh',e)}});
    try{accordions();videos();reviews();scrollers()}catch(e){console.error('hm-rh',e)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
